import Papa from 'papaparse';

export interface CSVRow {
  [key: string]: string;
}

export const loadCSV = async (csvContent: string): Promise<CSVRow[]> => {
  return new Promise((resolve, reject) => {
    Papa.parse(csvContent, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        if (results.errors.length > 0) {
          reject(new Error(`CSV parsing errors: ${results.errors.map(e => e.message).join(', ')}`));
        } else {
          resolve(results.data as CSVRow[]);
        }
      },
      error: (error: any) => {
        reject(error);
      }
    });
  });
};

export const loadCSVFromFile = async (filePath: string): Promise<CSVRow[]> => {
  try {
    const response = await fetch(filePath);
    if (!response.ok) {
      throw new Error(`Failed to load CSV file: ${response.statusText}`);
    }
    const csvContent = await response.text();
    return loadCSV(csvContent);
  } catch (error) {
    throw new Error(`Error loading CSV file ${filePath}: ${error}`);
  }
}; 